import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import LazyImage from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import KeepMeLoginModal from "@tSchaedlerYesco/Widgets/KeepMeLoginModal";
import React, { useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    canAddToCart: state.context?.settings?.settingsCollection?.productSettings?.canAddToCart,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface HeaderStyles {
    page?: MobiusPageProps;
    pageFixed?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    HeaderStripe?: InjectableCss;
    navBar?: InjectableCss;
    TXT2CHAT?: InjectableCss;
    ButtonWrapper?: InjectableCss;
}

export const headerStyles: HeaderStyles = {
    pageFixed: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            position: fixed !important;
                            z-index: 10;
                            width: 100%;
                            top: 0;
                            height: 50px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    container: {
        css: css`
            background-color: #333;
            display: flex;
            height: 40px;

            @media only screen and (max-width: 767px),
                only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                height: 60px;
                padding-left: 15px;
            }
            > div:first-child {
                flex-grow: 1;
            }
            .navBar {
                display: flex;
            }
            [class^="Wrapper"] {
                &:nth-child(2) {
                    width: 260px;
                    padding-right: 15px;
                    @media (max-width: 767px) {
                        width: 100%;
                        padding-right: 15px;
                    }
                }
                .phone-block {
                    border: 1px solid #000;
                    background: #000;
                    height: 40px;
                    padding: 2px 15px;
                    text-align: center;
                    cursor: pointer;
                    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
                        height: 50px;
                        padding: 7px;
                    }
                    @media (max-width: 767px) {
                        height: 55px;
                        padding: 10px;
                    }
                    a {
                        vertical-align: middle;
                        line-height: 8px;
                        &:hover {
                            color: #fff;
                        }
                        span {
                            color: #fff;
                            font-size: 18px;
                            font-weight: bold;
                            @media (max-width: 767px) {
                                font-size: 15px;
                            }
                        }
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                max-width: 67%;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },

    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },

    HeaderStripe: {
        css: css`
            line-height: 0;
            margin-bottom: -1px;
            img[class^="StyledImg"] {
                width: 100%;
            }

            [class^="LazyImageStyle"] {
                display: block;
                img {
                    height: 15px;
                }
            }
        `,
    },
    navBar: {
        css: css`
            max-width: 1440px;
            margin: auto;
        `,
    },
    TXT2CHAT: {
        css: css`
            width: 200px;
        `,
    },
    // ButtonWrapper: {
    //     css: css`
    //         position: sticky;
    //         bottom: 0;
    //         background-color: #ffffff;
    //         padding: 10px;
    //         > div[class^="container"] {
    //             position: relative;
    //             border: 2px solid green;
    //             background-color: white;
    //             margin: auto;
    //             padding: 15px;
    //         }
    //     `,
    // },
    page: {
        css: css`
            & + div[class^="PageStyle"] {
                nav[data-test-selector="pageBreadcrumbs"] {
                    .disable-breadcrumb {
                        pointer-events: none;
                    }
                }
            }
        `,
    },
};

logoStyles.wrapper = {
    css: css`
        max-width: 150px;
        max-height: 150px;
    `,
};

const styles = headerStyles;

declare global {
    interface Window {
        Velaro: any;
    }
}

const Header = ({
    id,
    siteName,
    session,
    toaster,
    history,
    myAccountPageUrl,
    dismissRfqUpdates,
    canAddToCart,
}: Props) => {
    const [pageYOffsetValue, setPageYOffsetValue] = useState(0);

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };
    useEffect(() => {
        disableBreadcrumbFunction();
    }, []);

    const disableBreadcrumbFunction = () => {
        const disableBreadcrumb: HTMLSelectElement | null = document.querySelector(
            '[data-test-selector="pageBreadcrumbs"] a:nth-of-type(2)',
        );

        if (disableBreadcrumb) {
            if (disableBreadcrumb.innerText === "Resources") {
                disableBreadcrumb.classList.add("disable-breadcrumb");
            } else {
                disableBreadcrumb.classList.remove("disable-breadcrumb");
            }
        }
    };

    // useEffect(() => {
    //     window.addEventListener("scroll", event => {
    //         setPageYOffsetValue(window.pageYOffset);
    //     });

    // if (session.hasRfqUpdates) {
    //     toaster.addToast({
    //         body: (
    //             <>
    //                 <Typography>{translate("You have new quote information.")}</Typography>
    //                 <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
    //             </>
    //         ),
    //         messageType: "info",
    //         timeoutLength: 1000 * 60 * 60 * 24 * 365,
    //         onClose: () => {
    //             dismissRfqUpdates();
    //         },
    //     });
    // }
    // if (document.getElementById("velarochat")) {
    //     return;
    // }
    // const globals = document.createElement("script");
    // globals.src = "https://galleryuseastprod.blob.core.windows.net/velaroscripts/20907/globals.js";

    // const inline = document.createElement("script");
    // inline.src = "https://eastprodcdn.azureedge.net/bundles/velaro.inline.js";

    // const scriptNode = document.getElementsByTagName("script")[0];
    // scriptNode && scriptNode.parentNode && scriptNode.parentNode.insertBefore(globals, scriptNode);

    //     globals.onload = function () {
    //         window.Velaro.Globals.ActiveSite = 20907;
    //         window.Velaro.Globals.ActiveGroup = 0;
    //         window.Velaro.Globals.InlineEnabled = true;
    //         window.Velaro.Globals.VisitorMonitoringEnabled = false;
    //         window.Velaro.Globals.InlinePosition = 0;
    //         scriptNode && scriptNode.parentNode && scriptNode.parentNode.insertBefore(inline, scriptNode);
    //     };
    // }, []);

    useEffect(() => {
        const CalendarScriptClassName = siteMessage("CalendarScriptClassName");
        if (document.getElementsByClassName("elfsight-app-df7c2f7f-3241-4240-89f6-1dc9356cba6e").length === 1) {
            return;
        }
        const elementCalendar = document.getElementById("elfsight_Calendar");
        const inlineElfsight = document.createElement("script");
        inlineElfsight.src = "https://static.elfsight.com/platform/platform.js";
        inlineElfsight.defer = true;
        elementCalendar?.append(inlineElfsight);
        const calendarDiv = document.createElement("div");
        calendarDiv.className = CalendarScriptClassName.toString();
        elementCalendar?.append(calendarDiv);
    });

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://client.moblico.net/txt2chat/?apikey=6eca7248-d06a-43fe-aa13-cc647acf0e39";
        document.body.appendChild(script);
    }, []);

    const afterHeader = React.createRef<HTMLSpanElement>();

    return (
        <>
            {siteName && <Typography {...styles.websiteName}>{siteName}</Typography>}
            <Page as="header" isHeader={true} {...styles.page} fullWidth={[true, true, true, true, true]}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                <EagerLoadingLogoProvider value={true}>
                    <StyledWrapper>
                        <Zone contentId={id} zoneName="languageDropdown"></Zone>
                    </StyledWrapper>
                    <Zone contentId={id} zoneName="SecondaryNavigation" fixed />
                    <StyledWrapper {...styles.HeaderStripe}>
                        <Zone contentId={id} zoneName="HeaderStripe" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.container}>
                        <StyledWrapper {...styles.navBar} className="navBar">
                            <Zone contentId={id} zoneName="MainNavigation" fixed />
                            <Zone contentId={id} zoneName="phoneNumber" />
                        </StyledWrapper>
                    </StyledWrapper>
                    <Zone contentId={id} zoneName="Breadcrumb" />
                </EagerLoadingLogoProvider>
                <span ref={afterHeader} tabIndex={-1} />
                <KeepMeLoginModal />

                <StyledWrapper
                    {...styles.ButtonWrapper}
                    css={css`
                        position: fixed;
                        bottom: 40%;
                        right: -75px;
                        padding: 0px;
                        z-index: 9999999;
                        transform: rotate(270deg);
                        /* Ensure it's on top of other content */
                        > div[class^="container"] {
                            position: relative;
                            border: 2px solid green;
                            background-color: white;
                            margin: auto;
                            padding: 15px;
                        }
                    `}
                >
                    <Clickable className="text2ChatBtn">
                        <LazyImage {...styles.TXT2CHAT} src="userfiles/TXT2CHAT.png"></LazyImage>
                    </Clickable>
                </StyledWrapper>
            </Page>
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
